<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <!-- <b-dropdown text="Action" variant="primary" class="mr-1">
          </b-dropdown> -->
          <button
            class="btn btn-primary mr-1"
            @click="showFilter = !showFilter"
          >
            <i class="fa fa-filter"></i> Filter
          </button>
          <b-button variant="primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i>Export
          </b-button>
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="5">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Debitur</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.customer"
                  placeholder="Customer"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label style="width: 100px">No. Kontrak</label>
                </b-input-group-prepend>
                <b-form-input
                  v-model="tblData.no_kontrak"
                  placeholder="No Kontrak"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Angsuran</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  separator=","
                  v-model="tblData.angsuran1"
                  :precision="2"
                ></my-number>

                <b-input-group-prepend>
                  <span class="input-group-text">until</span>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  separator=","
                  v-model="tblData.angsuran2"
                  :precision="2"
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <label>Tgl. Jth Tempo</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date"></b-form-input>
            <b-input-group-prepend>
              <span class="input-group-text">until</span>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date"></b-form-input>
            <b-input-group-prepend>
              <label class="mx-2">Out Standing</label>
            </b-input-group-prepend>
            <b-form-select
              v-model="tblData.outstand"
              :plain="true"
              :options="ostandStatus"
            ></b-form-select>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Collector</label>
            </b-input-group-prepend>
            <b-form-select
              v-model="tblData.collector_id"
              :plain="true"
              :options="collectors"
            ></b-form-select>
            <b-input-group-prepend>
              <span class="mx-2 pt-2">Entity</span>
            </b-input-group-prepend>
            <b-form-select
              v-model="tblData.sourceproject"
              :plain="true"
              :options="sourceproject"
            ></b-form-select>
            <b-input-group-append>
              <b-button
                variant="success"
                size="sm"
                @click="refresh()"
                class="ml-3"
              >
                <i class="fa fa-refresh"></i> Apply Filter
              </b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button
                variant="secondary"
                size="sm"
                class="ml-2"
                @click="clearFilter()"
                >Clear Filter</b-button
              >
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body class="mb-0">
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          style="font-size: smaller"
          :items="data"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit"
          :busy="isBusy"
          @row-clicked="rowClicked"
          show-empty
        >
          <template v-slot:cell(seq)="data">
            <span>
              {{ ((tblData.page-1)*tblData.limit) + (data.index + 1) }}
            </span>
          </template>
          <template v-slot:cell(angsuran_ke)="data">
            <div style="width: 100%; height: 100%">
              {{ data.item.angsuran_ke }}
            </div>
          </template>
          <template v-slot:cell(tgl_jttempo)="data">{{
            data.item.tgl_jttempo | moment("DD MMM YYYY")
          }}</template>
          <template v-slot:cell(nilai_pokok)="data">{{
            data.item.nilai_pokok | numFormat('(0,0.00)')
          }}</template>
          <template v-slot:cell(nilai_bunga)="data">{{
            data.item.nilai_bunga | numFormat('(0,0.00)')
          }}</template>
          <template v-slot:cell(angsuran)="data">{{
            data.item.angsuran | numFormat('(0,0.00)')
          }}</template>
          <template v-slot:cell(outstand_pokok)="data">{{
            data.item.outstand_pokok<0.009?0:data.item.outstand_pokok | numFormat('(0,0.00)')
          }}</template>
          <template v-slot:cell(outstand_bunga)="data">{{
            data.item.outstand_bunga<0.009?0:data.item.outstand_bunga | numFormat('(0,0.00)')
          }}</template>
          <template v-slot:cell(outstand_denda)="data">{{
            data.item.outstand_denda<0.009?0:data.item.outstand_denda | numFormat('(0,0.00)')
          }}</template>
          <template v-slot:cell(waktupelunasan)="data">{{
            data.item.waktupelunasan | moment("DD MMM YYYY")
          }}</template>

          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
        </b-table>
      </b-card>

      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="tblData.page * tblData.limit > tblData.total">{{
              tblData.total | numFormat
            }}</span>
            <span v-else>{{ (tblData.page * tblData.limit) | numFormat }}</span>
            of {{ tblData.total | numFormat }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top: 0 !important">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select
                  :options="[10, 15, 20, 25]"
                  :plain="true"
                  v-model="tblData.limit"
                  size="sm"
                  style="width: 80px"
                />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import myNumber from "../../components/my-number";
import moment from "moment";
import invout from "../../apis/logistic_inv_out";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import installment from "../../apis/installmentkredit";
import crud from "../../apis/crud";

toastr.init();
export default {
  components: { Loading, myNumber },
  data() {
    return {
      isLoading: false,
      showFilter: false,
      isBusy: false,
      model: {},
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:'',tgl2:'',
        // tgl1: this.$store.state.user.tglaktif,
        // tgl2: this.$store.state.user.akhirbln,
        sortBy: "no_kontrak",
        sortDesc: false,
        collector_id: "",
        sourceproject: this.$store.state.user.compcode || "",
        status: "",
        outstand: 1,
        wo_status:''
      },
      collectors: [{ value: "", text: "--- ALL ---" }],
      modelkredit: [
        { value: "", text: "--- ALL ---" },
        { value: "PAB", text: "Angsuran Bulanan" },
        { value: "PRK", text: "Rekening Koran" },
      ],
      kolStatus: [
        { value: "", text: "--- ALL ---" },
        { value: "1", text: "1" },
        { value: "2", text: "2" },
        { value: "3", text: "3" },
        { value: "4", text: "4" },
        { value: "5", text: "5" },
      ],
      statuses: [
        { value: "", text: "--- ALL ---" },
        { value: "secure", text: "Perform(Secure)" },
        { value: "unsecure", text: "Non Perform" },
      ],
      sourceproject: [{ value: "", text: "--- ALL ---" }],
      ostandStatus: dropdown.ostandStatus,
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "seq",
          label: "#",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "no_kontrak",
          label: "No Kontrak",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "CustName",
          label: "Debitur",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "angsuran_ke",
          label: "Angsuran Ke-",
          thStyle: "width:70px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "tgl_jttempo",
          label: "Tgl. Jatuh Tempo",
          thStyle: "width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "nilai_pokok",
          label: "Pokok",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "nilai_bunga",
          label: "Bunga(IDR)",
          thStyle: "width:60px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "angsuran",
          label: "Angsuran/bulan (IDR)",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstand_pokok",
          label: "Outstand Pokok",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstand_bunga",
          label: "Outstand Bunga",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstand_denda",
          label: "Outstand Denda",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  async created() {
    const this_ = this;
    // this.isBusy = true;
    // this.data();
    const collSet = {
      tablename: "vwcollector",
      // page: 1,
      // limit: 20,
      // total: 0,
    };
    const collector = await crud.list(collSet);
    collector.map((dt) => {
      this.collectors.push({ value: dt.collector_id, text: dt.crewname });
    });

    const sourcePr = await crud.list({
      tablename: "company",
      customQuery: "isdeleted=" + encodeURIComponent(0),
    });
    sourcePr.map((item) => {
      this_.sourceproject.push({ value: item.compcode, text: item.company });
    });
  },
  methods: {
    async pelunasan() {
      if (this.model.pinjamankey) {
        router.push({
          name: "loan.pelunasanfrm",
          params: { pinjamankey: this.model.pinjamankey },
        });
      } else {
        toastr.warn("Please select a row that want to view");
      }
    },
    async addpinjaman() {
      router.push({ name: "loan.pinjamankabfrm" });
    },

    async exportDtl() {
      if (this.model.pinjamankey) {
        try {
          await pinjaman.exportDtlxls(this.model.pinjamankey);
        } catch (error) {
          this.isBusy = false;
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      } else {
        toastr.warn("Please select a row that want to export detail");
      }
    },

    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      if (record.isReturn === 1) {
        this.disabledRetur = true;
      } else {
        this.disabledRetur = false;
      }

      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    data: async function (ctx) {
      try {
        if(this.$route.params){
          this.tblData.wo_status = this.$route.params.wo_status;
          this.tblData.tgl2 = moment(new Date(this.$route.params.tgl2)).format('YYYY-MM-DD');
        }
        const { list } = await installment.list(this.tblData);
        this.isBusy = false;
        return list;
      } catch (error) {
        console.log("error : ", error);
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData.customer = "";
      this.tblData.sourceproject = "";
      this.tblData.collector_id = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.angsuran1 = "";
      this.tblData.angsuran2 = "";
      this.tblData.no_kontrak = "";

      this.refresh();
    },
    async exportxls() {
      try {
        this.isLoading = true;
        await installment.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    close() {
      router.push("home");
    },
  },
};
</script>